import React, { useState, useEffect, useCallback } from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import Select from 'react-select';

const Product = () => {
    const [formData, setFormData] = useState({
        routeId: '',
        selectedMonth: new Date().toISOString().slice(0, 7),
        selectedProducts: []
    });
    const [routes, setRoutes] = useState([]);
    const [productOptions, setProductOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [allSelected, setAllSelected] = useState(false);

    // Fetch routes
    const fetchRoutes = useCallback(async () => {
        try {
            const response = await fetch('https://back.bidolux.jmatecnologia.inf.br/api/get-routes', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            setRoutes(data);
        } catch (error) {
            console.error('Error fetching routes:', error);
        }
    }, []);

    // Fetch products
    const fetchProducts = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await fetch('https://back.bidolux.jmatecnologia.inf.br/api/get-products', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            const options = data.map(item => ({
                value: item.id,
                label: item.cod_desc_prod,
                ...item
            }));
            setProductOptions(options);
        } catch (error) {
            console.error('Error fetching products:', error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchRoutes();
        fetchProducts();
    }, [fetchRoutes, fetchProducts]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const submitData = {
                routeId: formData.routeId,
                selectedMonth: formData.selectedMonth,
                selectedProducts: allSelected ? productOptions : formData.selectedProducts
            };
    
            console.log('Dados sendo enviados:', submitData);
    
            const response = await fetch('https://back.bidolux.jmatecnologia.inf.br/api/route-products/store', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(submitData)
            });
    
            const responseText = await response.text();
            console.log('Resposta bruta:', responseText);
    
            let data;
            if (responseText) {
                try {
                    data = JSON.parse(responseText);
                } catch (parseError) {
                    console.error('Erro ao fazer parse da resposta:', parseError);
                    throw new Error('Resposta inválida do servidor');
                }
            } else {
                throw new Error('Resposta vazia do servidor');
            }
    
            if (data.status === 'error') {
                console.error('Erro retornado pelo servidor:', data);
                alert('Erro: ' + JSON.stringify(data.message));
                return;
            }
            
            alert(data.message || 'Registro realizado com sucesso!');
        } catch (error) {
            console.error('Erro completo:', error);
            alert(`Erro ao enviar dados: ${error.message}`);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleProductSelect = (selectedOptions) => {
        if (selectedOptions && selectedOptions.value === 'all') {
            setAllSelected(!allSelected);
            setFormData(prev => ({
                ...prev,
                selectedProducts: []
            }));
        } else {
            setAllSelected(false);
            setFormData(prev => ({
                ...prev,
                selectedProducts: selectedOptions || []
            }));
        }
    };

    const customStyles = {
        control: (base) => ({
            ...base,
            marginTop: '5px'
        }),
        multiValue: (base, state) => ({
            ...base,
            backgroundColor: state.data.value === 'all' ? '#007bff' : base.backgroundColor,
            color: state.data.value === 'all' ? 'white' : base.color
        }),
        multiValueLabel: (base, state) => ({
            ...base,
            color: state.data.value === 'all' ? 'white' : base.color
        })
    };

    const allOption = {
        value: 'all',
        label: 'Selecionar Todos'
    };

    const getOptions = () => {
        return [allOption, ...productOptions];
    };

    const getValue = () => {
        if (allSelected) {
            return [allOption];
        }
        return formData.selectedProducts;
    };

    return (
        <Container className="py-4">
            <Row className="justify-content-center">
                <Col md={8}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Registro de Produtos em Rota</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Form onSubmit={handleSubmit}>
                                <Row className="mb-3">
                                    <Col md={12}>
                                        <Form.Group>
                                            <Form.Label>Frete</Form.Label>
                                            <Form.Select
                                                name="routeId"
                                                value={formData.routeId}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">Selecione o frete</option>
                                                {routes.map(route => (
                                                    <option key={route.id} value={route.id}>
                                                        {`${route.state_from} → ${route.state_to}`}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Form.Group className="mb-3">
                                    <Form.Label>Mês de Referência</Form.Label>
                                    <Form.Control
                                        type="month"
                                        name="selectedMonth"
                                        value={formData.selectedMonth}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Produtos</Form.Label>
                                    <Select
                                        isMulti
                                        isLoading={isLoading}
                                        options={getOptions()}
                                        value={getValue()}
                                        onChange={handleProductSelect}
                                        placeholder="Selecione os produtos"
                                        noOptionsMessage={() => "Nenhum produto encontrado"}
                                        classNamePrefix="select"
                                        isSearchable={true}
                                        isClearable={true}
                                        styles={customStyles}
                                    />
                                </Form.Group>

                                <div className="d-grid gap-2">
                                    <Button 
                                        variant="primary" 
                                        type="submit"
                                        disabled={isLoading}
                                    >
                                        {isLoading ? 'Carregando...' : 'Registrar'}
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Product;